module.exports = __webpack_public_path__ + "img/SKMJ_place2.c3c940fb.png";